/* eslint-disable id-length */
import keyMirror from 'keymirror';

export default keyMirror({
  ZILLOW_SECTION_TITLE_RENDERED: null,
  ZILLOW_BACKGROUND_RENDERED: null,
  ZILLOW_MESSAGE_TEXT: null
});
